import { render, staticRenderFns } from "./UserRoleHistory.vue?vue&type=template&id=4cf3418a"
import script from "./UserRoleHistory.vue?vue&type=script&lang=js"
export * from "./UserRoleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports